import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  exportAs: 'myreToggle',
  selector: 'myre-toggle, [myreToggle]',
})
export class ToggleDirective {
  public get off(): boolean {
    return !this._on;
  }

  public get on(): boolean {
    return this._on;
  }

  @Input()
  public set on(value: boolean) {
    this.setOnState(value);
  }

  @Output()
  public toggle = new EventEmitter<boolean>();

  private _on: boolean;

  public setOnState(on: boolean): void {
    this._on = !!on;
    this.toggle.emit(this._on);
  }
}
